import { BoutonMessages } from './bouton-messages';
import { GeneralMessages } from './general-messages';

export class VisualiserMessages {
	public boutonMessages = new BoutonMessages();
	public generalMessages = new GeneralMessages();

	public libelle = 'visualiser.libelle';
	public retour = 'visualiser.retour';
	public libelle_table_matieres = 'visualiser.libelle_table_matieres';
	public synthese = 'visualiser.synthese';
	public synthese_intitule = 'visualiser.synthese_intitule';
	public synthese_support = 'visualiser.synthese_support';
	public avis = 'visualiser.avis';
	public avis_identification = 'visualiser.avis_identification';
	public avis_objet = 'visualiser.avis_objet';
	public avis_renseignements = 'visualiser.avis_renseignements';
	public avis_procedure = 'visualiser.avis_procedure';
	public historique = 'visualiser.historique';
	public supprimer_libelle = 'visualiser.supprimer_libelle';
	public descriptionA = 'visualiser.supprimer_descA';
	public descriptionB = 'visualiser.supprimer_descB';
	public popupEnregistrerDesc = 'visualiser.enregistrer_description';
	public popupDupliquerDesc = 'visualiser.dupliquer_description';
	public popupCorrigerDesc = 'visualiser.corriger_description';
	public telecharger = this.boutonMessages.telecharger;
	public supprimer = this.boutonMessages.supprimer;
	public modifier = this.boutonMessages.modifier;
	public dupliquer_avis = this.boutonMessages.dupliquer_avis;
	public creer_avis = this.boutonMessages.creer_avis;
	public enregistrer = this.boutonMessages.enregistrer;
	public annuler = this.boutonMessages.annuler;
	public suivant = this.boutonMessages.suivant;
	public precedent = this.boutonMessages.precedent;
	public page = this.generalMessages.page;
	public lie_avis = this.boutonMessages.lie_avis;

	constructor() {}
}
